export enum GPIErrorCodes {
	PROCESSING_FORBIDDEN = 'processing_forbidden',
	INVALID_INPUT = 'invalid_input',
	INVALID_CARD = 'invalid_card',
	SERVER_ERROR = 'server_error',
	AUTHENTICATION_FAILED = 'authentication_failed',
	INVALID_PAYMENT_TOKEN = 'invalid_payment_token',
	INVALID_TEMPORARY_TOKEN = 'invalid_temporary_token',
	INVALID_TRANSACTION_REFERENCED = 'invalid_transaction_referenced',
	SERVICE_UNAVAILABLE = 'service_unavailable',
	SERVER_BUSY = 'server_busy',
}
